import { yupResolver } from "@hookform/resolvers/yup/dist/yup";
import { useForm } from "react-hook-form";
import APIS from "../../constant/EndPoint";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
//@ts-ignore
import { FormLayout } from "@careinfo/layout";
import ComboboxInput from "../Reusable/ComboboxInput";
import TextField from "../Reusable/TextInput";
import { createDeliveryChargeTemplateValidation } from "../../utils/validationSchemas";
import LocalCombobox from "../Reusable/LocalCombobox";
const CreateDeliveryChargeTemplate = (props: any) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    setError,
    setValue,
    getValues,
    clearErrors,
  } = useForm<any>({
    resolver: yupResolver(createDeliveryChargeTemplateValidation),
    defaultValues: async () => {
      return {
        base_weight: 1,
        base_piece: 1,
        base_volume: 1,
      };
    },
  });
  const { handleCreate, isLoading } = props;
  const TypeData = [
    {
      name: "Branch",
      id: "Branch",
    },
    {
      name: "Merchant",
      id: "Merchant",
    },
  ];
  return (
    <FormLayout
      handleSubmit={handleSubmit}
      handleFormSubmit={handleCreate}
      setError={setError}
      buttonLabel={"Create"}
      isLoading={isLoading}
    >
      <div className={tw`grid grid-cols-3 gap-x-2`}>
        <ComboboxInput
          label={"Delivery Charge Template"}
          placeholder={"Search Delivery Charge Template"}
          url={APIS.DELIVERY_CHARGE_TEMPLATE}
          props={{ is_active: true }}
          queryKey={"delivery-charge-template"}
          register={register("previous_delivery_charge_template")}
          errors={errors?.warehouse}
          name={"previous_delivery_charge_template"}
          setValue={setValue}
          getValues={getValues}
          clearErrors={clearErrors}
        />
        <LocalCombobox
          label={"Type"}
          placeholder={"Search type"}
          props={{ is_active: true }}
          register={register("type")}
          errors={errors?.type}
          name={"type"}
          setValue={setValue}
          getValues={getValues}
          clearErrors={clearErrors}
          data={TypeData}
        />
        <TextField
          label={"Name"}
          register={register("name")}
          errors={errors?.name}
        />
        <TextField
          label={"Base Weight"}
          register={register("base_weight")}
          errors={errors?.base_weight}
        />
        <TextField
          label={"Base Piece"}
          register={register("base_piece")}
          errors={errors?.base_piece}
        />
        <TextField
          label={"Base Volume"}
          register={register("base_volume")}
          errors={errors?.base_volume}
        />
      </div>
    </FormLayout>
  );
};

export default CreateDeliveryChargeTemplate;
